import React from 'react';
import { TriageTable } from './components/TriageTable';
export function App() {
  return <TriageTable data-id="element-0" />;
}